import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from "@angular/core";
import {AuthService} from "@app/core";


export const headersInterceptor: HttpInterceptorFn =
  (req, next) => {
    const authService = inject(AuthService)
    const token = authService.getAccessToken()

    const headers: Record<string, string> = {}

    if (token && !req.headers.has('Authorization')) {
      headers['Authorization'] = `Bearer ${token}`
    }

    if (!req.headers.has('Accept')) {
      headers['Accept'] = 'application/json'
    }

    if (
      !req.headers.has('Content-Type') &&
      req.method !== 'GET' &&
      !(req.body instanceof FormData)
    ) {
      headers['Content-Type'] = 'application/json'
    }

    headers['X-CLESAME-PATNER'] = 'xxxxxx'
    headers['X-CLESAME-APPLICATION'] = 'yyyy'
    headers['X-CLESAME-COMPONENT'] = 'zzzz'

    const requestToSend = req.clone({
      setHeaders: headers
    });
    return next(requestToSend).pipe()
  }

